import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";
import { api } from "./api";
import { useAuth } from "./auth";
import { DEFAULT_MONEY_PREFS, applyMoneyPrefs, moneyPrefs } from "./format";

const MoneyCtx = createContext(null);

export function MoneyProvider({ children }) {
  const { user, setUser } = useAuth();
  const [prefs, setPrefs] = useState(() => ({ ...moneyPrefs }));
  const serverPrefs = user ? user.prefs : null;
  useEffect(() => {
    const next = { ...DEFAULT_MONEY_PREFS, ...(serverPrefs || {}) };
    applyMoneyPrefs(next);
    setPrefs(next);
  }, [serverPrefs]);
  const toggle = useCallback((key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    applyMoneyPrefs(next);
    setPrefs(next);
    setUser((u) => (u ? { ...u, prefs: next } : u));
    api.put("/auth/me/prefs", next).catch(() => toast.error("✕ Preferenza non salvata sul server"));
  }, [prefs, setUser]);
  const value = useMemo(() => ({ prefs, toggle }), [prefs, toggle]);
  return <MoneyCtx.Provider value={value}>{children}</MoneyCtx.Provider>;
}

export const useMoney = () => useContext(MoneyCtx);
